import { useQuery } from '@tanstack/react-query';
import { container } from '@/app/container';
import { SalesRepositoryToken } from '../../di/tokens';

/** Página `/offers/:id` — a oferta com o gateway e a conta já resolvidos. */
export function useOffer(offerId: string) {
  const repository = container.resolve(SalesRepositoryToken);
  return useQuery({
    queryKey: ['sales', 'offer', offerId],
    queryFn: () => repository.getOffer(offerId),
    staleTime: 1000 * 60 * 5,
    enabled: !!offerId,
    retry: false,
  });
}
